import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import $ from 'jquery';
import FormField from './FormField';
import { getWorkflowTranslationHashTable,
         getExtraData, 
         transformTextFromPlaceholderMapping,
         getPublicIntakeFormLinkExtraData } from '../../helpers/utils';
import { isEmptyObject } from '../../validators/formValidators';


export const getPlaceholderArray = (currentConfig, loggedIn, currentCase = {}) => {
    let extraData = {};
    let rows = [];
    if (isEmptyObject(currentCase)) {
        extraData = getPublicIntakeFormLinkExtraData(currentCase, loggedIn, true);
    } else {
        extraData = getExtraData(currentCase, currentConfig, loggedIn, true);
        delete extraData['%docs.Signature'];
        delete extraData['%docs.Signature_Small'];
        rows = getWorkflowTranslationHashTable(currentConfig, currentCase, {}, undefined, true).map((x) => {
            let label = x.placeholder;
            if (x.label) {
                label = `${x.label} ${x.placeholder}`;
            }
    
            if (x.value && x.value !== '') {
                label += ` "${x.value}"`;
            }
    
            return { id: x.placeholder, value: x.placeholder, label };
        });
    }

    Object.keys(extraData).forEach((key) => {
        const placeholder = `{${key}}`;
        rows.unshift({
            id: placeholder,
            label: `${extraData[key].label} ${placeholder}`,
            value: placeholder,
        });
    });

    rows = rows.sort((a, b) => {
        return a.value.localeCompare(b.value);
    }).filter((item, pos, arr) => {
        return pos === 0 || item.value !== arr[pos - 1].value;
    });

    return rows;
};


export const addPlaceholdersHighlight = (html, currentConfig, loggedIn, currentCase = {}) => {
    if (!html || !html.startsWith('<') || !currentConfig || !loggedIn) {
        return html;
    }

    const placeholderArray = getPlaceholderArray(currentConfig, loggedIn, currentCase);
    if (!placeholderArray || placeholderArray.length === 0) {
        return html;
    }

    const data = {};
    placeholderArray.map((x) => { 
        data[x.value] = `<span class="mention" data-id="${x.value.replace(/[{}]/g, '')}" data-value="${x.value}"><span contenteditable="false">${x.value}</span></span>`
    });

    const result = transformTextFromPlaceholderMapping(html, data);
    return result;
};

export const removePlaceholdersHighlight = (html) => {
    if (!html || !html.startsWith('<')) {
        return html;
    }

    const el = document.createElement('div');
    el.innerHTML = html;
    const mentions = el.querySelectorAll('span.mention');
    for (let i = 0; i < mentions.length; i += 1) {
        const placeholder = mentions[i].attributes['data-value'].value;
        mentions[i].replaceWith(placeholder);
    }

    return el.innerHTML;
};


export const replaceValuesWithPlaceholders = (html) => {
    if (!html || !html.startsWith('<')) {
        return html;
    }

    const el = document.createElement('div');
    el.innerHTML = html;
    const mentions = el.querySelectorAll('span.mention');
    for (let i = 0; i < mentions.length; i += 1) {
        const placeholder = `{${mentions[i].attributes['data-id'].value.replace(/[{}]/g, '')}}`;
        // let innerHTML = mentions[i].innerHTML;
        // let start = Math.max(innerHTML.indexOf(">") + 1, 0);
        // let end = Math.max(innerHTML.indexOf("<", start), 0);
        // innerHTML = innerHTML.slice(0, start) + placeholder + innerHTML.slice(end);
        mentions[i].replaceWith(placeholder);
    }

    return el.innerHTML;
};


class TextEditor extends PureComponent {
    constructor(props) {
        super(props);
        this.onChange = this.onChange.bind(this);
        this.onBlur = this.onBlur.bind(this);
        this.emailInit = this.emailInit.bind(this);
        this.state = { editorReady: false };
    }

    async componentDidMount() {
        if (typeof document === 'undefined') return;
        const quillModule = await import('react-quill');
        this.ReactQuill = quillModule.default || quillModule;
        this.Quill = this.ReactQuill.Quill;
        if (this.props.isEmail || this.props.isSms) {
            this.QuillMention = await import('./QuillMention');
            this.emailInit();
        }
        // componentWillMount already populated this.modules with the default
        // toolbar; if this is an email/sms editor, swap in the mention-aware
        // modules now that Quill is loaded.
        this.setupModules();
        this.setState({ editorReady: true });
    }

    componentWillMount() {
        this.setupModules();
    }

    setupModules() {
        if ((this.props.isEmail || this.props.isSms) && this.Quill) {
            this.values = getPlaceholderArray(this.props.currentConfig, this.props.loggedIn, this.props.currentCase);
            let toolbar = false;
            if (this.props.isEmail) {
                toolbar = [
                    [{ 'font': [] }],
                    ['bold', 'italic', 'underline', 'strike'],        // toggled buttons
                    [{ 'color': [] }, { 'background': [] }],    // dropdown with defaults from theme
                    [{'list': 'ordered'}, {'list': 'bullet'}],
                    [{ 'indent': '-1'}, { 'indent': '+1' }],
                    [{ 'align': [] }],
                    ['clean']
                ];
            }

            this.modules = {
                toolbar,
                mention: {
                    allowedChars: /^[a-zA-Z0-9. ]*$/,
                    mentionDenotationChars: ['{'],
                    maxChars: 500,
                    minChars: 0,
                    renderItem(item) {
                        return `${item.label}`;
                    },
                    source: (searchTerm, renderList, _) => { 
                        this.renderList = renderList;                    
                        if (searchTerm.length === 0) {
                            renderList(this.values, searchTerm);
                        } else {
                            const matches = [];
                            for (let i = 0; i < this.values.length; i += 1) {
                                if (this.values[i].label.toLowerCase().indexOf(searchTerm.toLowerCase()) >= 0) {
                                    matches.push(this.values[i]);
                                }
                            }

                            renderList(matches, searchTerm);
                         }
                    },
                },
            };
        } else {
            this.modules = {
                toolbar: [
                    [{ 'size': [ 'small', false, 'large', 'huge' ]}],
                    [{ 'font': [] }],
                    ['bold', 'italic', 'underline', 'strike'],        // toggled buttons
                    [{ 'color': [] }, { 'background': [] }],    // dropdown with defaults from theme
                    ['blockquote'],
                    [{'list': 'ordered'}, {'list': 'bullet'}],
                    [{ 'script': 'sub'}, { 'script': 'super' }],      // superscript/subscript
                    [{ 'indent': '-1'}, { 'indent': '+1' }],
                    [{ 'align': [] }],
                    ['link', 'image'],
                    ['clean']
                ],
            };
        }

    }

    componentWillUnmount() {
        if (this.renderList) {
            this.renderList([], '');
        }

        $('div.ql-mention-list-container').remove();
    }

    onChange(value) {
        this.props.field.onChange(value);
        if (this.props.onChange) {
            this.props.onChange(value);
        }
    }

    onBlur(range) {
        if (this.props.onBlur) {
            this.props.onBlur(this.props.field.value, range);
        }
    }

    emailInit() {
        const Parchment = this.Quill.import('parchment');
        class IndentAttributor extends Parchment.Attributor.Style {
            add (node, value) {
                if (value === 0) {
                    this.remove(node);
                    return true;
                }
                
                return super.add(node, `${value}em`)
            }
        }

        this.IndentStyle = new IndentAttributor('indent', 'text-indent', {
            scope: Parchment.Scope.BLOCK,
            whitelist: ['1em', '2em', '3em', '4em', '5em', '6em', '7em', '8em', '9em']
        });

        this.Quill.register(this.Quill.import('attributors/style/color'), true);
        this.Quill.register(this.Quill.import('attributors/style/background'), true);
        this.Quill.register(this.Quill.import('attributors/style/direction'), true);
        this.Quill.register(this.Quill.import('attributors/style/align'), true);
        this.Quill.register(this.Quill.import('attributors/style/font'), true);
        this.Quill.register(this.IndentStyle, true);

        const Block = Parchment.query('block');
        Block.tagName = 'DIV';
        this.Quill.register(Block, true);
        this.Quill.register(this.QuillMention.MentionBlot);
        this.Quill.register('modules/mention', this.QuillMention.Mention);
    }

    render() {
        const {field, help, options, label, disabled, loading, rows, required, toolbarConfig, fullSize = true} = this.props;

        if (!this.state.editorReady || !this.ReactQuill) {
            return (
                <FormField required={required} field={field} help={help} loading label={label} forceFullSize={fullSize} style={{backgroundColor: '#FFF'}}>
                    <div />
                </FormField>
            );
        }

        return (
            <FormField required={required} field={field} help={help} loading={loading} label={label} forceFullSize={fullSize} style={{backgroundColor: '#FFF'}}>
                <this.ReactQuill value={field.value}
                                 theme="snow"
                                 modules={this.modules}
                                 onChange={this.onChange}
                                 onBlur={this.onBlur}
                                 readOnly={disabled}
                />
                <div className="br" />
                <div className="br" />
            </FormField>);
    }
}

TextEditor.propTypes = {
    field: PropTypes.object.isRequired,
    onChange: PropTypes.func,
    text: PropTypes.string,
    disabled: PropTypes.bool,
    toolbarConfig: PropTypes.object,
    isEmail: PropTypes.bool,
    isSms: PropTypes.bool,
    fullSize: PropTypes.bool,

    currentConfig: PropTypes.object,
    loggedIn: PropTypes.object,
    currentCase: PropTypes.object,
}

export default TextEditor;
